import cn from 'classnames'
import type { FC, PropsWithChildren } from 'react'

import css from '../List.css'

export const ListItemRight: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => {
  return <span className={cn(css.right, className)}>{children}</span>
}
